import script from "./ExamDelivery.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamDelivery.vue?vue&type=script&setup=true&lang=js"

import "./ExamDelivery.vue?vue&type=style&index=0&id=04680ce6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04680ce6"]])

export default __exports__